import React, { useRef, useState } from "react";
import "../kits.css";

import Footer from "..//../../components/Footer/Footer";
import Header from "../../../components/Header/Header";
import CardSpotlight from "../../../components/CardSpotlight/CardSpotlight";
import { useNavigate } from "react-router-dom";

const KitDigital = () => {
  const continueButtonRef = useRef(null);
  const [editable, setEditable] = useState(false);
  const [cantidadKits, setCantidadKits] = useState(1);
  const [showEditModal, setShowEditModal] = useState(false);

  // Se agregan precios a cada componente para que, si todos están seleccionados, sumen 5000 colones.
  const componentes = {
    "Compuerta NAND": {
      image: "/images/Kits/compuerta.jpg",
      description: "Compuerta de 2 entradas TTL modelo 74LS00",
      price: 750,
    },
    "Compuerta AND": {
      image: "/images/Kits/compuerta.jpg",
      description: "Compuerta de 2 entradas TTL modelo 74LS08",
      price: 750,
    },
    "Compuerta NOR": {
      image: "/images/Kits/compuerta.jpg",
      description: "Compuerta de 2 entradas TTL modelo 74LS02",
      price: 750,
    },
    "Compuerta OR": {
      image: "/images/Kits/compuerta.jpg",
      description: "Compuerta de 2 entradas TTL modelo 74LS32",
      price: 750,
    },
    "Compuerta NOT": {
      image: "/images/Kits/compuerta.jpg",
      description: "Compuerta TTL modelo 74LS04",
      price: 750,
    },
    "Dip switch 4 posiciones": {
      image: "/images/Kits/dip.jpg",
      description:
        "Son interruptores muy prácticos y sencillos de utilizar, muy recomendados para protoboard en el control de proyectos.",
      price: 400,
    },
  };

  // Extras (en este caso, solo se almacena la imagen)
  const extras = {
    "Caja de herramientas": "/images/Kits/caja.png",
    "Kit de puentes": "/images/Kits/puentes.png",
    Multimetro: "/images/Kits/multimetro.png",
    "3 metros de Cable": "/images/Kits/cable2.png",
  };

  // Precios para los extras
  const extrasPrices = {
    "Caja de herramientas": 2500,
    "Kit de puentes": 2000,
    Multimetro: 10000,
    "3 metros de Cable": 1200,
  };

  // Renderiza extras (se usa el objeto extrasPrices)
  const renderExtras = (items) => {
    return Object.keys(items).map((component, index) => (
      <CardSpotlight
        key={index}
        className="extra-item"
        onClick={() => toggleComponent(component)}
      >
        <p className="extra-name">{component}</p>
        <p className="extra-price">₡{extrasPrices[component]}</p>
        <img src={items[component]} alt={component} className="extra-image" />
        <input
          type="checkbox"
          checked={selectedComponents[component]}
          onChange={() => toggleComponent(component)}
          onClick={(e) => e.stopPropagation()}
        />
      </CardSpotlight>
    ));
  };

  // Estado que gestiona qué componentes y extras están seleccionados
  const [selectedComponents, setSelectedComponents] = useState({
    ...Object.keys(componentes).reduce(
      (acc, key) => ({ ...acc, [key]: true }),
      {}
    ),
    ...Object.keys(extras).reduce((acc, key) => ({ ...acc, [key]: false }), {}),
  });

  // Función para alternar selección de cada componente/extra
  const toggleComponent = (name) => {
    setSelectedComponents((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  // Calcula el precio sumando los precios de los componentes y extras seleccionados,
  // y lo multiplica por la cantidad de kits.
  const calculatePrice = () => {
    // Verifica si todos los componentes (excluyendo los extras) están seleccionados
    const allComponentsSelected = Object.keys(componentes).every(
      (key) => selectedComponents[key]
    );

    // Si todos los componentes están seleccionados, usamos el precio descontado; de lo contrario, sumamos normalmente.
    let priceComponents = allComponentsSelected
      ? 4000
      : Object.keys(componentes).reduce(
          (sum, key) =>
            selectedComponents[key] ? sum + componentes[key].price : sum,
          0
        );

    // Sumamos los extras normalmente (si están seleccionados)
    let priceExtras = Object.keys(extras).reduce(
      (sum, key) => (selectedComponents[key] ? sum + extrasPrices[key] : sum),
      0
    );

    // Retornamos el total multiplicado por la cantidad de kits
    return (priceComponents + priceExtras) * cantidadKits;
  };

  // Función para el botón de “Editar/Guardar”
  const handleEditClick = () => {
    console.log("handleEditClick:", { editable, showEditModal });
    if (!editable) {
      setShowEditModal(true);
    } else {
      setEditable(false);
    }
  };

  const handleModalAccept = () => {
    console.log("Modal aceptado");
    setEditable(true);
    setShowEditModal(false);
  };

  // Función para reservar (puedes mantenerla o modificarla según necesidades)
  const handleReserve = () => {
    if (continueButtonRef.current) {
      continueButtonRef.current.scrollIntoView({ behavior: "smooth" });
    }
    console.log("Reservar:", { selectedComponents, cantidadKits });
  };

  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/kits/checkout", {
      state: {
        price: calculatePrice(),
        nombre: "Kit de Electronica Digital",
        selectedComponents,
        cantidadKits,
      },
    });
  };

  // Renderiza los componentes (de la misma forma que antes)
  const renderComponents = (items, isEditable) => {
    return Object.keys(items).map((component, index) => (
      <CardSpotlight key={index} className="component-item">
        <div className="component-content">
          <img
            src={items[component].image}
            alt={component}
            className="component-image"
          />
          <div className="component-description">
            {items[component].description}
          </div>
        </div>
        <div className="component-bottom">
          <p className="component-name">{component}</p>
          {editable && (
            <input
              type="checkbox"
              checked={selectedComponents[component]}
              onChange={() => toggleComponent(component)}
            />
          )}
        </div>
      </CardSpotlight>
    ));
  };

  return (
    <div className="kit-container">
      <Header />

      <div className="kit-content">
        <div className="kit-header">
          <img
            src="/images/digital.png"
            alt="Kit de Circuitos"
            className="kit-image"
          />
          <div className="kit-info">
            <h1>Kit de Electrónica Digital</h1>
            <h3>
              Con este kit tendrás todo lo que necesitas para el Laboratorio de
              Electrónica Digital.
            </h3>
          </div>
        </div>

        {/* <div className="kits-buttons">
          <button onClick={handleReserve}>Reservar</button>
        </div> */}
        <div className="kits-buttons">
          <button onClick={handleEditClick}>
            {editable ? "Guardar" : "Editar"}
          </button>
        </div>

        <h2>Componentes del Kit</h2>
        <div className="components-grid">
          {renderComponents(componentes, editable)}
        </div>

        <h2>Extras disponibles</h2>
        <div className="extras-grid">{renderExtras(extras)}</div>

        {/* Precio dinámico calculado según los componentes extras y cantidad de kits */}
        <h2>Precio: ₡{calculatePrice()} colones</h2>

        <div className="kits-quantity">
          <label>
            Cantidad de kits:
            <input
              type="number"
              min="1"
              value={cantidadKits}
              onChange={(e) => setCantidadKits(parseInt(e.target.value))}
            />
          </label>
        </div>

        <div className="kits-buttons">
          <button ref={continueButtonRef} onClick={handleContinue}>
            Continuar
          </button>
        </div>
      </div>

      <Footer />

      {/* Ventana modal para confirmar la acción de editar */}
      {showEditModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p> A continuación, puede editar su kit quitando componentes</p>
            <p>
              ATENCIÓN: Al eliminar cualquier componente de su kit se renuncia a
              un descuento especial.
            </p>
            <p>
              En caso de pedir múltiples kits, las modificaciones alterarán a
              todos los kits. Si esto no se desea, realice múltiples órdenes
            </p>
            <div className="kits-buttons">
              <button onClick={handleModalAccept}>Aceptar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KitDigital;
